import dotenv from 'dotenv';
dotenv.config();



// WEBPACK FOOTER //
// ./src/app/env.js